import api from '../api/api';

class ChatbotFavouriteService {
  static async getFavourites(): Promise<number[]> {
    const response = await api.get<number[]>('/chatbots/favourites');
    return response.data;
  }

  static async addFavourite(chatbotId: number): Promise<void> {
    await api.post(`/chatbots/favourites/${chatbotId}`);
  }

  static async removeFavourite(chatbotId: number): Promise<void> {
    await api.delete(`/chatbots/favourites/${chatbotId}`);
  }
}

export default ChatbotFavouriteService;
